import Api from '.';

/**
 * Retrieve all HealthProfessionAssociationUF.
 */
export function listHealthProfessionAssociationUF() {
  return Api.get('/health-profession-association-uf');
}

export function listDropdownHealthProfessionAssociationUF() {
  return Api.get('/health-profession-association-uf/listDropdown');
}
